import type { CognitoUser } from "@aws-amplify/auth";

type CustomCognitoAttributes = {
  name: string;
  email: string;
  "cognito:groups": string;
  "custom:SchoolId": string;
  "custom:DistributorId": string;
  "custom:UserId": string;
  "custom:Role": string;
};

export type CustomCognitoUser = CognitoUser & {
  attributes: CustomCognitoAttributes;
};

export interface AuthenticationCredentials {
  emailAddress: string;
  password: string;
}

export type SignUpParameters = AuthenticationCredentials;

export interface VerifyEmailAddressParameters {
  emailAddress: string;
  verificationCode: string;
}

export type SignInParameters = AuthenticationCredentials;

export interface SendPasswordResetEmailParameters {
  emailAddress: string;
}

export interface ChangePasswordParameters {
  emailAddress: string;
  verificationCode: string;
  newPassword: string;
}

export interface UpdatePasswordParameters {
  user: CustomCognitoUser;
  currentPassword: string;
  newPassword: string;
}

export interface CompleteNewPasswordParameters {
  user: CustomCognitoUser;
  password: string;
}

export const enum CognitoErrorMessage {
  USER_DISABLED = "User is disabled.",
}
